import React, { useState }  from 'react';
import { Link, useNavigate } from "react-router-dom";

// images 
import painting from "../../assets/images/services/painting.png";
import carpetCleaning from "../../assets/images/services/carpet-cleaning.png";
import cleaning from "../../assets/images/services/cleaning.png";
import landscaping from "../../assets/images/services/landscaping.png";
import dryWallRepair from "../../assets/images/services/drywall-repair.png";
import { useSelector, useDispatch } from "react-redux";
import { useEffect } from 'react';
import ReactImageFallback from 'react-image-fallback';
import { setServices } from "../../redux/features/services.feature";

import featuredImage from "../../assets/images/default_featured_img.png";

const Banner1 = (props) => {

  const navigate = useNavigate();
  let dispatch = useDispatch();

  const [services, setServices] = useState("");

  const islogin = useSelector(state => state.auth.isLogin);
  const token = useSelector(state => state.auth.token);
  const userData = useSelector(state => state.auth.data);

  const getServices = async () => {
    await fetch(`${process.env.REACT_APP_BASE_URL}/api/services`, {
      method: "GET", 
    })
    .then(r => r.json())
    .then(response => {
      if(response.success){
        
        let data = response.records.data.slice(0,3);
        // console.log(data);
        setServices(data);
        dispatch(setServices(response.records.data));
      }
    })
  }
  useEffect(() => {
    getServices();
  }, []);


  const handleClick = () => {
    if(islogin && token.length > 0){
      // console.log(userData);
      if(userData?.role == 3){
        navigate("/create-job");
      } else {
        navigate("/jobs");
      }
    } else {
      navigate("/signin");
    }
  }

  return (
    <>
      {/* <!-- BANNER START --> */}
      <div className="bds-bannerv2">
        <span className="bds-shade"></span>
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-xl-10">
              <div className="bds-bannerv2_title">
                <h1>Find the perfect</h1>
                <h4>Contractor for you</h4>
              </div>
              <ul className="bds-mainbtnlist bds-mainlist-two">
                <li>
                  <Link to={`${islogin && token ? '/jobs' : '/signup'}`} className="bds-btn-solid-lg bds-btn-yellow">
                      Get Started Now
                  </Link>
                </li>
                <li>
                  <Link to="/jobs" 
                      className="bds-btn-line-lg bds-btn-plain theme-rounded">
                      I’m looking for a work                
                  </Link>
                </li>
              </ul>
              <ul className="bds-explore-categories justify-content-center">
                
                {
                  services && 
                  services?.map((item, idx) => 
                    <li key={idx} onClick={handleClick}>
                      <div className="bds-explore-content">
                        <figure>
                          <ReactImageFallback 
                            src={`${process.env.REACT_APP_BASE_URL}/public/storage/${item?.service_image}`}
                            initialImage={featuredImage}
                            fallbackImage={featuredImage}
                            alt="images" 
                            width={100} 
                            height={80} 
                          />
                        </figure>
                        <div className="bds-explore-info">
                          <h6>Painting</h6>
                          {/* <span>321247 Listings</span> */}
                        </div>
                      </div>
                    </li>                  
                  )
                }                
                {
                  Object.keys(services).length > 4 ? 
                  <li>
                  <div className="bds-explore-content bds-exploremore-two">
                    <div className="bds-explore-info">
                      <h5>Explore more categories</h5>
                      <Link to="#" className="bds-btn-solid-sm bds-btn-yellow">
                          Explore all
                      </Link>
                    </div>
                  </div>
                </li> : ""
                }

              </ul>
            </div>
          </div>
        </div>
      </div>
      {/* <!-- BANNER END --> */}
    </>
  );
};


export default Banner1;